var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 21,
    viewBox: "0 0 55 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2223 0.550171L10.9385 5.41233H4.13379L5.46532 0.550171H12.2223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4356 7.31702L6.95574 20.5H0L3.61102 7.31702H10.4356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0923 5.41233H14.7808L13.812 0.550171H20.9665L22.0923 5.41233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 7.31702L25.4432 19.8784L24.9325 20.5H17.7869L17.6776 19.9496V19.9486L15.1606 7.31702H22.5337L23.5801 11.8323L26.6644 7.31702H35.8669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2871 0.60022L37.531 5.41225H28.248L31.7478 0.60022H41.2871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8204 5.41228H39.5981L43.7716 0.5H50.8267L51.8204 5.41228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 20.4498H47.8453L45.858 12.3295H34.0332L38.4054 7.31702H52.3169L53.3105 12.3295L54.9998 20.4498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvaLogo);
export default __webpack_public_path__ + "static/media/iva-logo.2d359f360facb10280d5cabd3c331c99.svg";
export { ForwardRef as ReactComponent };